"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ponte-nelle-alpi": {
    "5ae02b88": [{
      "hkey": "0a3fa625",
      "slug": "soccher-paiane-casan-arsie",
      "name": "Soccher-Paiane-Casan-Arsie",
      "primary": true,
      "skipSearch": false
    }],
    "pajane": [{
      "hkey": "0a3fa625",
      "slug": "soccher-paiane-casan-arsie",
      "name": "Soccher-Paiane-Casan-Arsie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;